module.exports = __webpack_public_path__ + "img/Giguo.c2074d7b.svg";